/* =========================================================================
   Phrase Studios -- "The Circle" email-capture popup (2026-06-21, v5)
   Offer: Join The Circle -> 10% off your first order (code PHRASE10,
   the same code the live Welcome Series already emails, so popup + email match).
   Auto-opens after 5s (or 35% scroll / exit-intent). No teaser pill.
   No em dashes in copy (brand rule). Wired to Klaviyo client subscribe API:
   subscribes to the Email List (VksCP3) -> triggers the live Welcome Series.
   Split layout: brand hero photo (home_hero_friends_flowers) + offer.
   Copy uses HTML entities (&#39; &middot;) so the source stays pure ASCII.
   ========================================================================= */
(function () {
  'use strict';

  var COMPANY_ID = 'TDuvHK';
  var LIST_ID = 'VksCP3';
  var KEY = 'phrase_circle_popup_v3';
  var CODE = 'PHRASE10';
  var SHOW_AFTER_MS = 5000;
  var SHOW_AFTER_SCROLL = 0.35;
  var SNOOZE_DAYS = 30;
  var IMG = 'https://cdn.shopify.com/s/files/1/0583/5269/7552/files/home_hero_friends_flowers.jpg?width=900';

  var path = location.pathname.toLowerCase();
  if (path.indexOf('/checkout') === 0 || path.indexOf('/cart') === 0) return;
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) {
      var st = JSON.parse(raw);
      if (st && st.subscribed) return;
      if (st && st.snoozedUntil && Date.now() < st.snoozedUntil) return;
    }
  } catch (e) {}

  function save(obj) { try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {} }
  function snooze() { save({ snoozedUntil: Date.now() + SNOOZE_DAYS * 864e5 }); }
  function markSubscribed() { save({ subscribed: true }); }

  var css = [
  '.pcircle{position:fixed;z-index:9000;right:24px;bottom:24px;width:560px;max-width:calc(100vw - 32px);',
  'background:var(--phrase-surface,#fff);color:var(--phrase-ink,#0B0B0A);',
  'font-family:var(--phrase-font-body,"Inter Tight",system-ui,sans-serif);',
  'border:1px solid var(--phrase-hairline,#E6E6E6);box-shadow:0 18px 50px rgba(11,11,10,.18);overflow:hidden;',
  'transform:translateY(16px);opacity:0;pointer-events:none;transition:opacity .28s cubic-bezier(.16,1,.3,1),transform .28s cubic-bezier(.16,1,.3,1);}',
  '.pcircle.is-open{opacity:1;transform:translateY(0);pointer-events:auto;}',
  '.pcircle__row{display:flex;align-items:stretch;}',
  '.pcircle__row .pcircle__media{display:block;flex:0 0 210px;background:#e9e7e2 url(' + IMG + ') center 18% / cover no-repeat;min-height:360px;}',
  '.pcircle__in{flex:1 1 auto;min-width:0;padding:26px 24px 22px;}',
  '.pcircle__badge{display:inline-block;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;',
  'color:var(--phrase-green,#2D4A15);border:1px solid var(--phrase-green,#2D4A15);border-radius:999px;padding:3px 9px;margin-bottom:12px;}',
  '.pcircle__h{margin:0 0 8px;font-size:22px;line-height:1.12;font-weight:700;letter-spacing:-.01em;}',
  '.pcircle__h em{font-style:normal;color:var(--phrase-green,#2D4A15);}',
  '.pcircle__p{margin:0 0 16px;font-size:13.5px;line-height:1.5;color:var(--phrase-ink-soft,#5b5b58);}',
  '.pcircle__form{display:flex;flex-direction:column;gap:8px;}',
  '.pcircle__input{width:100%;height:48px;padding:0 14px;border:1px solid var(--phrase-ink,#0B0B0A);',
  'border-radius:0;font:inherit;font-size:15px;background:#fff;color:var(--phrase-ink,#0B0B0A);box-sizing:border-box;}',
  '.pcircle__input:focus{outline:2px solid var(--phrase-green,#2D4A15);outline-offset:-2px;}',
  '.pcircle__btn{height:48px;border:0;border-radius:999px;background:var(--phrase-green,#2D4A15);color:#fff;',
  'font:inherit;font-size:14px;font-weight:600;letter-spacing:.02em;cursor:pointer;transition:opacity .2s;}',
  '.pcircle__btn:hover{opacity:.9;}.pcircle__btn:disabled{opacity:.6;cursor:default;}',
  '.pcircle__fine{margin:10px 0 0;font-size:11px;line-height:1.4;color:var(--phrase-ink-mute,#9a9a96);}',
  '.pcircle__err{margin:8px 0 0;font-size:12px;color:#B42318;display:none;}.pcircle__err.is-on{display:block;}',
  '.pcircle__code{display:inline-block;margin-top:4px;padding:8px 16px;border:1px dashed var(--phrase-green,#2D4A15);',
  'border-radius:8px;font-weight:700;font-size:16px;letter-spacing:.12em;color:var(--phrase-green,#2D4A15);}',
  '.pcircle__close{position:absolute;top:8px;right:8px;width:34px;height:34px;border:0;background:rgba(255,255,255,.75);',
  'cursor:pointer;color:var(--phrase-ink,#0B0B0A);font-size:20px;line-height:1;border-radius:999px;z-index:1;}',
  '.pcircle__close:hover{background:#fff;}',
  '.pcircle__ok{display:none;}.pcircle.is-done .pcircle__offer{display:none;}.pcircle.is-done .pcircle__ok{display:block;}',
  '@media (max-width:600px){',
  '.pcircle{left:0;right:0;bottom:0;width:100%;max-width:100%;border-left:0;border-right:0;border-bottom:0;',
  'border-radius:16px 16px 0 0;transform:translateY(100%);}',
  '.pcircle.is-open{transform:translateY(0);}',
  '.pcircle__row{flex-direction:column;}',
  '.pcircle__row .pcircle__media{flex:none;width:100%;height:132px;min-height:0;background-position:center 22%;}',
  '.pcircle__in{padding:20px 20px 22px;}}'
  ].join('');

  var BOX_HTML = [
  '<button class="pcircle__close" type="button" aria-label="Close">&times;</button>',
  '<div class="pcircle__row">',
  '<div class="pcircle__media" role="img" aria-label="Phrase Studios, The Circle"></div>',
  '<div class="pcircle__in">',
  '<div class="pcircle__offer">',
  '<span class="pcircle__badge">The Circle &middot; Welcome offer</span>',
  '<h2 class="pcircle__h"><em>10% off</em> your first order.</h2>',
  '<p class="pcircle__p">Join The Circle and we&#39;ll take 10% off your first order, plus early access to every chapter drop before it&#39;s public.</p>',
  '<form class="pcircle__form" novalidate>',
  '<input class="pcircle__input" type="email" inputmode="email" autocomplete="email" placeholder="Email address" aria-label="Email address" required>',
  '<button class="pcircle__btn" type="submit">Get my 10% off</button>',
  '<p class="pcircle__err">That email didn&#39;t go through. Try again?</p>',
  '</form>',
  '<p class="pcircle__fine">Free to join. Circle-only drops; unsubscribe anytime.</p>',
  '</div>',
  '<div class="pcircle__ok">',
  '<h2 class="pcircle__h">You&#39;re in The Circle.</h2>',
  '<p class="pcircle__p">Here&#39;s 10% off your first order, also sent to your inbox. Use it at checkout:</p>',
  '<span class="pcircle__code">' + CODE + '</span>',
  '</div>',
  '</div></div>'
  ].join('');

  function mount() {
    if (document.querySelector('.pcircle')) return;
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

    var box = document.createElement('div');
    box.className = 'pcircle'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Join The Circle');
    box.innerHTML = BOX_HTML;
    document.body.appendChild(box);

    function openBox() { box.classList.add('is-open'); setTimeout(function () { var i = box.querySelector('.pcircle__input'); if (i) i.focus(); }, 300); }
    function collapse() { box.classList.remove('is-open'); snooze(); }

    box.querySelector('.pcircle__close').addEventListener('click', collapse);

    box.querySelector('.pcircle__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = box.querySelector('.pcircle__input');
      var btn = box.querySelector('.pcircle__btn');
      var err = box.querySelector('.pcircle__err');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.classList.add('is-on'); input.focus(); return; }
      err.classList.remove('is-on'); btn.disabled = true; btn.textContent = 'Joining...';

      var payload = { data: { type: 'subscription', attributes: {
        custom_source: 'Circle popup (site)',
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: LIST_ID } } } } };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          markSubscribed(); box.classList.add('is-done');
          if (window.klaviyo && window.klaviyo.identify) { try { window.klaviyo.identify({ email: email }); } catch (e) {} }
        } else { throw new Error('status ' + r.status); }
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Get my 10% off'; err.classList.add('is-on');
      });
    });

    var armed = false;
    function arm() { if (armed) return; armed = true; openBox(); }
    setTimeout(arm, SHOW_AFTER_MS);
    window.addEventListener('scroll', function onScroll() {
      var sc = (window.scrollY || 0) / Math.max(1, (document.body.scrollHeight - window.innerHeight));
      if (sc >= SHOW_AFTER_SCROLL) { arm(); window.removeEventListener('scroll', onScroll); }
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      if (!armed && e.clientY <= 0 && window.innerWidth > 600) arm();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
